///jacques-andre-editeur\proshop-v2\frontend\src\screens\BooksCollectionsScreen.jsx
//import { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useGetBooksCollectionsQuery } from '../slices/booksCollectionsApiSlice';
import BooksCollectionCard from '../components/BooksCollectionCard';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Paginate from '../components/Paginate';
import Meta from '../components/Meta';

const BooksCollectionsScreen = () => {

  const params = useParams();

  // Utilisation de useState pour gérer les valeurs des paramètres
  const [pageNumber, setPageNumber] = useState(params.pageNumber || 1);
  //const [keyword, setKeyword] = useState(params.keyword || '');

  // Effect pour mettre à jour si params change
  useEffect(() => {
    setPageNumber(params.pageNumber || 1);
    //setKeyword(params.keyword || '');
  }, [params]);

  const parPage = 12;

  const { data, isLoading, error } = useGetBooksCollectionsQuery({
    //keyword,
    pageNumber,
    parPage
  });


  console.log('data dans le screen BooksCollectionsScreen.jsx : ', data)

  return (
    <>
      <Meta />
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>
          {error?.data?.message || error.error}
        </Message>
      ) : (
        <Container>
          <div className="h1-container">
            <h1>Nos collections</h1>
          </div>
          <div className="booksCollectionRow">
            {data?.booksCollections
            ?.filter((booksCollection) => booksCollection.name !== 'Hors collection')
            .map((booksCollection) => (
              <div className="booksCollection-card" key={booksCollection._id}>
                <BooksCollectionCard booksCollection={booksCollection} />
              </div>
            ))}
            </div>
          <Paginate pages={data.pages} page={data.page} basePath="/collections" />
        </Container>
      )}
    </>
  );
};

export default BooksCollectionsScreen;
